module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/towel-b13a818f37b91b94d6f206125d6693c4.svg";